import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const DividerBox = styled(Box)`
  background: rgba(255, 255, 255, 0.2);
  height: 0.06rem;
  width: 100%;
  margin: 1rem 0 1rem 0;
`;
